import { InjectedWindow } from '../../utils/types'

declare const window: InjectedWindow

/**
 * Useful at the launch to detect if Metamask is already connected to the website
 */
export async function lookIfConnected(): Promise<boolean> {
  if (isCypressInjected()) {
    return true
  }
  const unlocked = await isProviderUnlocked()
  const hasProvider = getCurrentProviderType() !== undefined
  const hasAddress =
    window.ethereum && window.ethereum.selectedAddress !== undefined
  return hasAddress && hasProvider && unlocked
}

export async function isProviderUnlocked(): Promise<boolean | undefined> {
  if (!window.ethereum) {
    return undefined
  }
  if (isCypressInjected()) {
    return true
  }
  const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  return accounts.length > 0
}

// It's only a string key like 'Injected', not a real provider Object
// Note that this is not only metamask, but added by Web3Modal
// (https://github.com/oceanprotocol/react/issues/60)
// TODO rename
// TODO create a real async from web3Modal.connect().then(_provider =>{...})
function getCurrentProviderType(): string | undefined {
  const value = localStorage.getItem('WEB3_CONNECT_CACHED_PROVIDER')
  return value || undefined
}

export function isCypressInjected() {
  return !!(window.ethereum && window.ethereum.isCypress)
}

export function isCoinbaseInjected() {
  return !!(window.ethereum && window.ethereum.isCoinbaseWallet)
}

export function isMetamaskInjected() {
  return !!(window.web3 && window.web3.__isMetaMaskShim__)
}

export function isProbablyBrave() {
  return !!window.navigator.brave
}

// @ts-ignore
window.getCurrentProviderType = getCurrentProviderType
// @ts-ignore
window.isCoinbaseInjected = isCoinbaseInjected
// @ts-ignore
window.isMetamaskInjected = isMetamaskInjected

export function getProviderType(): string {
  if (getCurrentProviderType() === undefined) {
    return 'not connected'
  }

  if (isCypressInjected()) {
    return 'cypress'
  }
  if (isProbablyBrave() && getCurrentProviderType() === '"injected"') {
    return 'brave'
  }
  if (isCoinbaseInjected() && getCurrentProviderType() === '"injected"') {
    return 'coinbase'
  }
  if (isMetamaskInjected() && getCurrentProviderType() === '"injected"') {
    return 'metamask'
  }

  // all others (should be ledger by the way....)
  return 'wallet-connect'
}

export function getAvailableProviderList() {
  const list = ['wallet-connect']
  if (isProbablyBrave()) {
    list.push('brave')
  } else {
    if (isCoinbaseInjected()) {
      list.push('coinbase')
    }
    if (isMetamaskInjected()) {
      list.push('metamask')
    }
  }
  return list
}
